export default __webpack_public_path__ + "53b3a0ac07c43e1ed41e23be5f092e41.svg";